import Signup from "./components/Signup/Signup";

export default Signup;
